/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { TrustRelationshipCreateRequest } from '@modules/cloud-api/v1/types'
import type { AsyncRequestState } from '@modules/ui-types'

import { createTrustRelationshipRequest } from '@/reducers/asyncRequests/registry'

import {
  createTrustRelationship,
  fetchTrustRelationship,
  resetCreateTrustRelationship,
} from '../../../actions/trustManagement'

import TrustRelationshipFlyout from './TrustRelationshipFlyout'

import type { ThunkDispatch, ReduxState } from '@/types/redux'

interface StateProps {
  onSaveRequest: AsyncRequestState
}

interface DispatchProps {
  onSave: (payload: TrustRelationshipCreateRequest) => Promise<unknown>
  resetOnClose: () => void
}

interface ConsumerProps {
  regionId: string
}

const mapStateToProps = (state: ReduxState, { regionId }: ConsumerProps): StateProps => ({
  onSaveRequest: createTrustRelationshipRequest(state, regionId),
})

const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  { regionId }: ConsumerProps,
): DispatchProps => ({
  onSave: (payload) =>
    dispatch(createTrustRelationship({ regionId, payload })).then((response) =>
      // We fetch again after create, as the create payload doesn't include the certificate
      dispatch(
        fetchTrustRelationship({
          regionId,
          trustRelationshipId: response.payload?.id as string,
          includeCertificate: true,
        }),
      ),
    ),
  resetOnClose: () => dispatch(resetCreateTrustRelationship(regionId)),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(TrustRelationshipFlyout)
